<template>
  <v-menu
    v-model="menu"
    :close-on-content-click="false"
    transition="scale-transition"
    offset-y
    max-width="290"
    min-width="290"
    content-class="responsive-menu"
  >
    <template #activator="{ props }">
      <v-text-field
        :model-value="formattedDate"
        :label="label"
        readonly
        v-bind="props"
        variant="outlined"
        :required="isRequired"
        density="compact"
        hide-details
        append-inner-icon="mdi-calendar"
        :disabled="disabled"
        :rules="isRequired ? [required] : []"
      />
    </template>

    <v-date-picker
      v-model="internalDate"
      locale="ru"
      @update:modelValue="onDateSelected"
    />
  </v-menu>
</template>

<script>
export default {
  name: 'DatePickerField',
  props: {
    modelValue: [String, Date],
    label: String,
    disabled: Boolean,
    isRequired: Boolean,
    required: {
      type: Function,
      default: () => (v) => !!v || 'Это поле обязательно',
    }
  },
  data() {
    return {
      menu: false,
      internalDate: this.modelValue || null,
    }
  },
  watch: {
    modelValue(newVal) {
      this.internalDate = newVal
    }
  },
  computed: {
    formattedDate() {
      const date = typeof this.internalDate === 'string'
        ? new Date(this.internalDate)
        : this.internalDate

      if (!date || isNaN(date.getTime())) return ''

      const day = String(date.getDate()).padStart(2, '0')
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const year = date.getFullYear()
      return `${day}.${month}.${year}`
    }
  },
  methods: {
    onDateSelected(val) {
      this.menu = false
      this.$emit('update:modelValue', val)
    }
  }
}
</script>
